<form name="targetForm" [formGroup]="targetForm" class="email-form">
    <section class="sideRight-body email-shelf__form email-drawer-body">
        <div>
            <div>
                <label (click)="divEvent($event);" class="rde-row label-style"
                    [ngClass]="{'placeholders-margin': selectedSmeName?.length > 0}">
                    <div (click)="divEvent($event);" class="col-11 placeholders-block sme-placeholderwidth">
                        <b>Placeholders : </b>
                        <span *ngFor="let placeholder of placeholders; last as isLast">{{placeholder}} {{isLast?'':',
                            '}}</span>
                    </div>

                </label>
            </div>
            <label (click)="divEvent($event);" class="rde-row label-style"
                [ngClass]="{'sme-margin-bottom': selectedSmeName?.length > 0}">
                <div (click)="divEvent($event);" class="col-1 bold-font lable-width">To : <span offset="0" theme="light"
                        autoPlacement="true" zIndex="20000" placement="bottom"
                        tooltip="The {{sendSmeList.length}} SME/SMEs listed here will get an individual email directed to them with the content in the box below. Everyone in CC will be copied in all emails. If you want to tweak the email for an SME different from the other SMEs, select the box next to their name and tweak the email content"
                        class="info-icon mr-2"><i class="fas fa-info-circle"></i> </span></div>
                <div (click)="divEvent($event);" class="col-11 no-padding">
                    <div (click)="divEvent($event);" class="smes-list-for-email email-textbox-width">
                        <ng-container>
                            <div (click)="divEvent($event);"
                                *ngFor="let item of sendSmeList; let i = index;first as isFirst">
                                <div (click)="divEvent($event);">
                                    <span *ngIf="selectedSmeId !== item.userId">
                                        <input id="smeCheckbox" type="checkbox" class="sme-checkbox"
                                            [checked]="selectedSmeId === item.userId"
                                            (click)="fetchSMETemplate(item.userId, $event);" />
                                    </span>
                                    <span *ngIf="selectedSmeId === item.userId">
                                        <input id="smeCheckbox" type="checkbox" class="sme-checkbox"
                                            [checked]="selectedSmeId === item.userId"
                                            (click)="fetchSMETemplate(item.userId, $event);" />
                                    </span>
                                    <span (click)="divEvent($event);"
                                        [ngClass]="{'active': selectedSmeId === item.userId}" class="sme-foremail"> {{
                                        item.displayName }} </span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </label>
        </div>
        <div>
            <label *ngIf="selectedSmeName?.length > 0">
                <span class="placeholders-block"> <span class="info-icon mr-2"><i class="fas fa-info-circle"></i>
                    </span> You are making changes to the email going out to
                    <span class="sme-name">{{selectedSmeName}}</span></span>
            </label>
        </div>

        <div>
            <label class="rde-row label-style">
                <div class="col-1 bold-font lable-width">CC :</div>
                <div class="col-11 no-padding email-textbox-width">
                    <div class="cc-dropdown">
                        <ng-multiselect-dropdown [placeholder]="'Add Client Managers/KPMG Users'"
                            [settings]="dropdownSettings" [data]="dropdownList" [(ngModel)]="selectedcCList"
                            [ngModelOptions]="{standalone: true}" (onSelect)="onItemSelect($event)"
                            (onDeSelect)="onItemDeSelect($event)" class="full-width">
                        </ng-multiselect-dropdown>
                        <div class="right-buttons">
                            <div *ngIf="(roleId === championRole || roleId === adminRole) && !isRcnSurveyApp"
                                class="set-default" [ngClass]="{'disabled': !setAsDefaultEnabled}"
                                (click)="setCcAsDefaultClick()">
                                Set as default
                            </div>
                            <div class="search-icon"><i class="fas fa-search"></i></div>
                        </div>
                    </div>
                </div>
            </label>
        </div>
        <div id="wrapper">
            <label (click)="divEvent($event);" class="subjectLabel rde-row label-style">
                <div (click)="divEvent($event);" class="col-1 bold-font lable-width">Subject :</div>
                <div class="col-11  no-padding">
                    <input class="black-input opposite-colors" type="text" formControlName="subject"
                        [(ngModel)]="emailSubject" (input)="inputSubjectChanged($event);updateSubject()" maxlength="100"
                        required>
                </div>
            </label>
        </div>

        <div *ngIf="(roleId === championRole || roleId === adminRole) && !isRcnSurveyApp">
            <div class="rde-row pad-sides sm-col custom-template-dropd">
                <div *ngIf="!showSaveTemplateOption" class="col-1  custom-template-dropdown">
                    <custom-dropdown class="button-height" [selectText]="customTemplateTitle"
                        [inputTooltip]="defaultTemplateToolTip" [options]="customTemplateTitleOptions"
                        (optionSelectedEvent)="onCustomTemplateTitleSelected($event)">
                    </custom-dropdown>
                </div>
                <div class="col-4 no-padding" *ngIf="showSaveTemplateOption">
                    <input class="black-input opposite-colors custom-template-textbox button-height"
                        placeholder="Enter template name" type="text" no-special-chars="#!$%^<>+='"
                        (blur)="trimSpecialChar('templateName');" maxlength="100" formControlName="templateName"
                        required />
                </div>
                <div *ngIf="showSaveTemplateOption || showSaveButton" class="col-1 button-space">
                    <button type='button' class="btn savebtn-success button-height"
                        [disabled]="isDisableCustomTemplateButton" (click)="saveModifiedCustomTemplate()">
                        Save
                    </button>
                </div>

                <div *ngIf="!showSaveTemplateOption" class="col-1 button-space">
                    <button type='button' class="btn savebtn-success button-height"
                        [disabled]="isDisableCustomTemplateButton" (click)="saveNewCustomTemplate()">
                        Save as
                    </button>
                </div>
                <div *ngIf="showSaveTemplateOption" class="col-1 button-space button-height">
                    <button (click)="cancelSaveCustomTemplate()" class="link-button-top-border">Cancel</button>
                </div>
                <div class="link-button-top-border button-height" *ngIf="showDeleteButton"
                    (click)="deletionCustomTemplate()" tooltip="Delete This Template">
                    <span autoPlacement="true" zIndex="20000" placement="bottom" tooltip="Delete This Template"> <i
                            class="fa fa-trash"></i> </span>
                </div>
                <div *ngIf="showRefreshButton" class="link-button-top-border button-height"
                    (click)="resetModifiedEmail()" tooltip="Reset Template">
                    <span autoPlacement="true" zIndex="20000" placement="bottom" tooltip="Reset Template"> <i
                            class="fa fa-refresh"></i> </span>
                </div>
                <div class="col-1 bold-font tabletooltip">
                    <span offset="0" theme="light"
                        autoPlacement="true" zIndex="20000" placement="bottom"
                        tooltip="{{tableGuidanceToolTip}}"
                        class="color-blue mr-2">
                        Add a table? <i class="fas fa-info-circle "></i> 
                    </span>
                </div>
                <div class="col-1 bold-font tabletooltip">
                    <span offset="0" theme="light"
                        autoPlacement="true" zIndex="20000" placement="bottom" 
                        [options] = "myOptions"
                        tooltip="{{linkGuidanceToolTip}}"
                        class="color-blue mr-2">
                        Have you checked the links? <i class="fas fa-info-circle "></i> 
                    </span>
                </div>
                <div *ngIf="this.emailPopupData.requestTemplateType === 1" class="toggle-auto-reminder">
                    <toggle-switch [switchState]="getSwitchState()"
                        [isDisabled]="isSwitchDisabled()"
                        [ngClass]="getSwitchStyle()" [title]="getToggleTooltip()"
                        (toggleState)="toggleAutoReminderTemplate($event)">
                    </toggle-switch>
                    <span *ngIf="!isReminderEnabled" class="info-icon mr-2">
                        <i class="fas fa-info-circle" [title]="remindersDisabledToolTip"></i>
                    </span>
                    <span>Use this as auto-reminder email</span>
                </div>
                
            </div>
        </div>

        <div *ngIf="modifyDefaultTemplate" class="NgxEditor__Wrapper" id="wrapper">
            <angular-editor id="editor1" formControlName="emailTemplate" [config]="editorConfig"
                [(ngModel)]="emailContent" [mention]="placeholders" [mentionConfig]="mentionConfig"
                (input)="inputEmailContentChanged($event);" [ngModelOptions]="{standalone: true}">
            </angular-editor>
        </div>

    </section>
    <footer class="endFormSubmit info-tile">
        <div *ngIf="selectedSmeName?.length > 0">
            <div>
                <label class="rde-row label-style">
                    <button type='button' class="btn btn-success" [disabled]="isDisableSendMailButton"
                        (click)="sendEmailtoSelected($event)">
                        Send to {{selectedSmeName}}
                    </button>
                    <button *ngIf="isKPMGUser && !isRcnSurveyApp" type='button' class="btn btn-success"
                        [disabled]="isDisableSendMailButton" (click)="sendPreviewEmail('preview')">
                        Send me test email
                    </button>
                    <button (click)="closeRightSideDrawer()" class="link-button-top-border">Cancel</button>
                </label>
            </div>
        </div>
        <button *ngIf="selectedSmeName?.length <= 0" type='button' class="btn btn-success"
            [disabled]="isDisableSendMailButton" (click)="sendEmail()">
            Send to SMEs
        </button>
        <button *ngIf="isKPMGUser && selectedSmeName?.length <= 0 && !isRcnSurveyApp" type='button'
            class="btn btn-success" [disabled]="isDisableSendMailButton" (click)="sendPreviewEmail('preview')">
            Send me test email
        </button>
        <button *ngIf="selectedSmeName?.length <= 0" (click)="closeRightSideDrawer()"
            class="link-button-top-border">Cancel</button>
    </footer>
</form>